import React from 'react';
import useMediaQuery from '../../Hooks/useMediaQuery';
import { Spin, Tooltip } from 'antd';
import { ArrowUp, ArrowDown, Info, NextArrow, ArrowLeft } from '../../assets/icons';
import SMHeader from '../../components/SMHeader/SMHeader';
import { Link, useParams } from 'react-router-dom';
import MarketFooter from '../../components/MarketFooter/MarketFooter';
import { useOwnedAssetDetails } from '../../Hooks/useOwnedAssetDetails';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getUsCurrencyFormat, getUsCurrencyFormatWithoutDecimal, getUsPercentageFormat } from '../../utils/usCurrencyFormatter';
import { getDateFormat } from '../../utils';
import { useState, useRef } from 'react';
import { useMemo } from 'react';
import moment from 'moment';
import { fwtchOwnedAssetCharts } from '../../services/PortfolioApi/portfolioApi';
import { toastNotify } from '../../utils/toastNotify';
import PortfolioBarchart from '../../components/Charts/PortfolioBarchart';
import TradeModal from '../PropertyListing/TradeModal';
import TradeDrawer from '../PropertyListing/TradeDrawer';
import useQuickBuySecondary from '../../Hooks/useQuickBuySecondary';
import { notifyMeForProperty } from '../../store/reducer/notifyMeSlice';
import NotifyMeModal from '../../components/NotifyMeModal/NotifyMeModal';

const TIMELINE_LABELS = ['7D', '1M', '6M', '1Y', 'YTD', 'MAX'];

const DURATION_LABELS = {
  '7D': 'prev 7d',
  '1M': 'prev 1M',
  '6M': 'prev 6M',
  YTD: 'year to date',
  '1Y': 'prev 1Y',
  MAX: 'all time',
};

const INTERVALS = {
  '7D': 0,
  '1M': 6,
  '6M': 0,
  '1Y': 0,
  YTD: 0,
  MAX: 0,
};

const SEONDARYOBJ = {
  propertyId: 0,
  propertyName: '',
  label: '',
  cityName: '',
  cityId: 0,
  stateId: 0,
  stateName: '',
  propertyCreatedAt: '',
  images: {},
  propertyType: '',
  dividendYield: 0.0,
  lastTradedPrice: 0,
  allTime: 0.0,
  bids: 0,
  asks: 0,
  likedByLoggedInUser: null,
};

const AssetDetails = (props) => {
  const { data } = useSelector((state) => state.propertyDetails);
  const quickBuySecondaryData = useMemo(() => {
    return {
      ...SEONDARYOBJ,
      propertyId: data?.data?.propertyId,
      propertyName: data?.data?.name,
      label: data?.data?.tag,
      cityName: data?.data?.city,
      cityId: 0,
      stateId: 0,
      stateName: data?.data?.state,
      propertyCreatedAt: '',
      images: data?.data?.images,
      propertyType: data?.data?.propertyTypeName,
      dividendYield: data?.data?.tenantStatus?.dividendYield,
      lastTradedPrice: Number(data?.data?.lastPrice),
      allTime: getUsPercentageFormat(
        (100 * (Number(data?.data?.lastPrice) - Number(data?.data?.finance?.perSharePrice))) / Number(data?.data?.finance?.perSharePrice) || 0
      ),
      bids: data?.data?.totalBids,
      asks: data?.data?.totalAsks,
      likedByLoggedInUser: null,
    };
  });
  const screenMD = useMediaQuery('(min-width: 1000px)');
  const { propertyId } = useParams();
  const screenSM = useMediaQuery('(min-width: 640px)');
  const { fetchOwnedAssets, fetchPropertyDetails } = useOwnedAssetDetails();
  const [selectedTimeline, setSelectedTimeline] = useState('1M');
  const [isFetchingChart, setIsFetchingChart] = useState(false);
  const [timelineChartData, setTimelineChartData] = useState(null);
  const [isSellOpen, setIsSellOpen] = useState('1');
  const [openQuickBuy, setOpenQuickBuy] = useState();
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [newsLetterChecked, setNewsLetterChecked] = useState(false);
  const [storeNotifyMeData, setStoreNotifyMeData] = useState({});
  const [isShowFullDate, setIsShowFullDate] = useState(true);
  const quickBuySecondaryOptions = useQuickBuySecondary(setOpenQuickBuy, quickBuySecondaryData, data);
  const userProfileData = useSelector((state) => state.userData.userData);
  const formRef = useRef();
  const dispatch = useDispatch();
  const {
    data: {
      data: {
        position: {
          currentValue = 0,
          appreciationLast30day = 0,
          appreciationPtageLast30day = 0,
          quantity = 0,
          averagePrice = 0,
          portfolioVolume = 0,
          equity = 0,
          userInvestmentStartDate = '',
          chartStartDate = '',
          chartEndDate = '',
        } = {},
        return: returnData = [],
        investmentSummary: { totalInvestment = 0, totalGain = 0, unrealizedGain = 0 } = {},
        dividend: { lastDividend = 0, nextDividend = 0, averageYield = 0, allTimeEarning = 0 } = {},
        currentShareData: { lowestAsk = 0, highestBid = 0, low52week = 0, high52week = 0, lastDividendPerShare = 0 } = {},
      } = {},
    } = {},
    loading,
  } = useSelector(({ ownedAssetDetails }) => ownedAssetDetails);

  const portfolioAge = useMemo(() => {
    return moment().diff(moment(userInvestmentStartDate || new Date()), 'months') || 0;
  }, [userInvestmentStartDate]);

  const timelineLabels = useMemo(() => {
    return portfolioAge < 6 ? TIMELINE_LABELS.filter((x) => x !== '6M' && x !== '1Y') : TIMELINE_LABELS;
  }, [portfolioAge]);

  useEffect(() => {
    if (propertyId) {
      fetchPropertyDetails(propertyId);
      fetchOwnedAssets(propertyId);
    }
  }, [propertyId]);

  const handleSelectTimeline = async (label) => {
    try {
      setSelectedTimeline(label);
      setIsFetchingChart(true);
      if (label !== '1M') {
        const data = await fwtchOwnedAssetCharts(propertyId, label);
        data.data.chartData = data?.data?.chartData?.map((x) => ({
          ...x,
          sharesTotal: x?.profit,
          dividendTotal: x?.totalDividend,
        }));
        setTimelineChartData(data?.data);
      }
    } catch (err) {
      toastNotify('error', err?.response?.data?.message || 'Failed getting chart data');
    } finally {
      setIsFetchingChart(false);
    }
  };
  const generateDummyDataBetweenDates = (start, end = moment(), diff = 'day') => {
    try {
      const data = [];
      for (let i = moment(start); i.isBefore(moment(end)); i.add(1, diff)) {
        data.push({
          date: i.toISOString(),
          total: 0,
          sharesTotal: 0,
          dividendTotal: 0,
        });
      }
      return data;

    } catch (error) {
      return []
    }
  };

  const generateDummyDataBetweenMonths = (start, end = moment(), diff = 'day') => {
    const startMonth = moment(start).month();
    const endMonth = moment(end).month();
    const durationInDays = moment(end).diff(start, 'days');
    if (durationInDays <= 31) {
      // If the difference between start and end is less than or equal to 31 days, generate day-wise data
      return generateDummyDataBetweenDates(start, end, 'day');
    }
    // Generate month-wise data
    const data = [];
    let tempDate = moment(start);
    try {
      for (let i = startMonth; i <= endMonth; i++) {
        const monthEndDate = tempDate.endOf('month').toDate();
        const lastDayOfMonth = moment(monthEndDate).date();
        for (let j = tempDate.date(); j <= lastDayOfMonth; j++) {
          data.push({
            date: tempDate.toISOString(),
            total: 0,
            sharesTotal: 0,
            dividendTotal: 0,
          });
          tempDate.add(1, 'day');
        }
      }
    } catch (error) {
      console.error('Error generating data:', error);
    }
    return data;
  };

  const handleChartDataUpdate = ({ timelineChartData, period, fullDateOptions, options }) => {
    return (
      generateDummyDataBetweenDates(timelineChartData?.startDate, timelineChartData?.endDate, period)?.map((x) => {
        const currentDateDataFromAPI = timelineChartData?.chartData?.find((apiData) => moment(apiData.date).isSame(x.date, period));
        if (currentDateDataFromAPI) {
          return {
            ...currentDateDataFromAPI,
            fullDate: getDateFormat({
              date: new Date(x.date),
              options: fullDateOptions,
            }),
            date: getDateFormat({
              date: new Date(x.date),
              options,
            }),
          };
        }
        return {
          ...x,
          fullDate: getDateFormat({
            date: new Date(x.date),
            options: fullDateOptions,
          }),
          date: getDateFormat({
            date: new Date(x.date),
            options,
          }),
        };
      }) || []
    );
  };
  const chartData = useMemo(() => {
    if (!isFetchingChart) {
      let fullDateOptions = {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      };
      switch (selectedTimeline) {
        case '7D':
          setIsShowFullDate(true)
          return (
            handleChartDataUpdate({
              timelineChartData,
              period: 'days',
              fullDateOptions,
              options: {
                weekday: 'short',
              },
            }) || []
          );

        case '1M':
          !isShowFullDate && setIsShowFullDate(true)
          const data = {
            chartData: returnData?.map((x) => ({
              ...x,
              sharesTotal: x?.pricePerShare,
              dividendTotal: x?.totalDividend,
            })),
            startDate: chartStartDate,
            endDate: chartEndDate,
          };
          return (
            handleChartDataUpdate({
              timelineChartData: data,
              period: 'days',
              fullDateOptions,
              options: {
                month: 'short',
                day: 'numeric',
              },
            }) || []
          );

        case '6M':
          setIsShowFullDate(false)
          return (
            handleChartDataUpdate({
              timelineChartData,
              period: 'months',
              fullDateOptions,
              options: {
                month: 'short',
              },
            }) || []
          );

        case 'YTD':
          setIsShowFullDate(false)
          let YTDData =
            generateDummyDataBetweenDates(timelineChartData?.startDate, timelineChartData?.endDate, 'months')
          YTDData[YTDData.length - 1].date = timelineChartData.chartData[timelineChartData.chartData.length - 1]?.date;
          return (
            YTDData?.map((x) => {
              const currentDateDataFromAPI = timelineChartData?.chartData?.find((apiData) => moment(apiData.date).isSame(x.date, 'month'));
              if (currentDateDataFromAPI) {
                return {
                  ...currentDateDataFromAPI,
                  fullDate: getDateFormat({
                    date: new Date(x.date),
                    options: fullDateOptions,
                  }),
                  date: getDateFormat({
                    date: new Date(x.date),
                    options: {
                      month: 'short',
                      year: 'numeric'
                    },
                  }),
                };
              }
              return {
                ...x,
                fullDate: getDateFormat({
                  date: new Date(x.date),
                  options: fullDateOptions,
                }),
                date: getDateFormat({
                  date: new Date(x.date),
                  options: {
                    month: 'short',
                    year: 'numeric'
                  },
                }),
              };
            }) || []
          );
        case '1Y':
          return (
            handleChartDataUpdate({
              timelineChartData,
              period: 'months',
              fullDateOptions,
              options: {
                month: 'short',
              },
            }) || []
          );
        case 'MAX':
          // This depends on portfolio age
          let options = {
            month: 'short',
            day: 'numeric',
          };
          setIsShowFullDate(true)
          let diff = 'days';
          if (portfolioAge >= 1) {
            setIsShowFullDate(false)
            options = {
              month: 'short',
              year: 'numeric',
            };
            diff = 'months';
          }
          let MAXData = generateDummyDataBetweenMonths(userInvestmentStartDate, timelineChartData?.endDate, diff)
          MAXData[MAXData.length - 1].date = timelineChartData.chartData[timelineChartData.chartData.length - 1]?.date;
          return (

            MAXData?.map((x) => {
              const currentDateDataFromAPI = timelineChartData?.chartData?.find((apiData) => moment(apiData.date).isSame(x.date, diff));
              if (currentDateDataFromAPI) {
                return {
                  ...currentDateDataFromAPI,
                  fullDate: getDateFormat({
                    date: new Date(x.date),
                    options: fullDateOptions,
                  }),
                  date: getDateFormat({
                    date: new Date(x.date),
                    options,
                  }),
                };
              }
              return {
                ...x,
                fullDate: getDateFormat({
                  date: new Date(x.date),
                  options: fullDateOptions,
                }),
                date: getDateFormat({
                  date: new Date(x.date),
                  options,
                }),
              };
            }) || []
          );

        default:
          break;
      }
    }
    return [];
  }, [selectedTimeline, isFetchingChart, timelineChartData, portfolioAge, returnData]);

  const getPortfolioBarchartInterval = () => {
    if (selectedTimeline === 'MAX') {
      if (portfolioAge < 15) {
        return 0; // Set interval to 0 if the portfolio age is less than 15 days
      } else if (portfolioAge > 1) {
        return parseInt(chartData.length / 6); // Set interval to 1/6th of the data length if the portfolio age is greater than 1 year
      } else {
        return 1; // Set interval to 1 day if the portfolio age is greater than 15 days and less than 1 year
      }
    } else {
      return INTERVALS[selectedTimeline]; // Use the regular interval for other timelines
    }
  };
  const portfolioBarchartInterval = getPortfolioBarchartInterval()

  const handleNotifyMe = async (value) => {
    await dispatch(
      notifyMeForProperty(
        Object.keys(userProfileData).length
          ? {
            propertyId: value?.id,
            forSecondary: value?.isSecondary,
            onSuccess: () => {
              setOpen(false);
              setEmail('');
              setNewsLetterChecked(false);
              formRef?.current?.resetFields();
            },
          }
          : {
            propertyId: storeNotifyMeData?.id,
            forSecondary: storeNotifyMeData?.isSecondary,
            signUpForNewsletter: newsLetterChecked,
            email: value.email,
            onSuccess: () => {
              setOpen(false);
              setEmail('');
              setNewsLetterChecked(false);
              formRef?.current?.resetFields();
            },
          }
      )
    );
  };

  const currentAppreciationData = useMemo(() => {
    const data = {
      currentAppreciation: 0,
      currentAppreciationPtage: 0,
    };
    if (!isFetchingChart) {
      if (selectedTimeline === '1M') {
        data.currentAppreciation = appreciationLast30day;
        data.currentAppreciationPtage = appreciationPtageLast30day;
      } else {
        data.currentAppreciation = timelineChartData?.profit || 0;
        data.currentAppreciationPtage = timelineChartData?.profitPtage || 0;
      }
    }
    return data;
  }, [selectedTimeline, isFetchingChart, timelineChartData, portfolioAge, returnData, appreciationLast30day, appreciationPtageLast30day]);

  return (
    <>
      {screenMD ? (
        <TradeModal
          quickBuySecondaryOptions={quickBuySecondaryOptions}
          open={openQuickBuy}
          modalState={setOpenQuickBuy}
          quickBuyPropertyData={quickBuySecondaryData}
          isSingleTab={false}
          isSell={isSellOpen}
          propertyDetailData={data}
          featchData={() => setOpenQuickBuy()}
        />
      ) : (
        <TradeDrawer
          quickBuySecondaryOptions={quickBuySecondaryOptions}
          open={openQuickBuy}
          modalState={setOpenQuickBuy}
          quickBuyPropertyData={quickBuySecondaryData}
          isSingleTab={false}
          isSell={isSellOpen}
          propertyDetailData={data}
          featchData={() => setOpenQuickBuy()}
        />
      )}
      <div className='container-fluid smdetails'>
        <div className='d-flex justify-content-space-between align-items-center py-20 smnav'>
          <div className='smnav__back'>
            <Link className='text-almost-black' to='/portfolio'>
              <ArrowLeft verticalAlign='-7px' marginRight='12px' />
            </Link>
            <span className='fw-600 fz-14'>Back to Portfolio</span>
          </div>
        </div>
        <SMHeader
          onNotifyClick={(value) => {
            Object.keys(userProfileData).length ? handleNotifyMe(value) : setStoreNotifyMeData(value) || setOpen(true);
          }}
          propertyDetail={data?.data}
          setIsSellOpen={setIsSellOpen}
          clickAction={setOpenQuickBuy}
        />
        <Spin spinning={loading || isFetchingChart}>
          <div className='smsummary__numbers mt-48 mb-24'>
            <div className='mb-24 w-100 fz-18 fw-600'>Position</div>
            <span className='h2 mb-4 current'>${getUsCurrencyFormat(Number(currentValue) || 0)}</span>
            {!screenSM && (
              <span
                className={`smsummary__numbers--mobile w-100 ${Number(currentAppreciationData?.currentAppreciationPtage) >= 0 ? 'growth' : 'loss'}`}
              >
                <span className='value'>
                  {Number(currentAppreciationData?.currentAppreciation) < 0 ? '-' : '+'}$
                  {getUsCurrencyFormat(
                    Number(currentAppreciationData?.currentAppreciation) < 0
                      ? -Number(currentAppreciationData?.currentAppreciation)
                      : Number(currentAppreciationData?.currentAppreciation) || 0
                  )}
                </span>
                <span className={`percentage ${Number(currentAppreciationData?.currentAppreciationPtage) >= 0 ? 'growth' : 'loss'}`}>
                  ({getUsPercentageFormat(Number(currentAppreciationData?.currentAppreciationPtage) || 0)}%)
                </span>
                <span className='duration'>
                  {Number(currentAppreciationData?.currentAppreciationPtage) >= 0 ? (
                    <ArrowUp verticalAlign='-2px' />
                  ) : (
                    <ArrowDown verticalAlign='-2px' />
                  )}{' '}
                  {DURATION_LABELS?.[selectedTimeline]}
                </span>
              </span>
            )}
            {!!screenSM && (
              <span className={`smsummary__numbers--desktop ${Number(currentAppreciationData?.currentAppreciationPtage) >= 0 ? 'growth' : 'loss'}`}>
                <span className='percentage'>
                  {Number(currentAppreciationData?.currentAppreciationPtage) >= 0 ? (
                    <ArrowUp verticalAlign='-2px' marginRight='8px' />
                  ) : (
                    <ArrowDown verticalAlign='-2px' marginRight='8px' />
                  )}
                  {getUsPercentageFormat(Number(currentAppreciationData?.currentAppreciationPtage) || 0)}%
                </span>
                <span className='value'>
                  {Number() < 0 ? '-' : ''}$
                  {getUsCurrencyFormat(
                    Number(currentAppreciationData?.currentAppreciation) < 0
                      ? -Number(currentAppreciationData?.currentAppreciation)
                      : Number(currentAppreciationData?.currentAppreciation) || 0
                  )}
                </span>
                <span className='duration'>{DURATION_LABELS?.[selectedTimeline]}</span>
              </span>
            )}
          </div>
          <div className='asset-details-data'>
            <div className='data-list'>
              <div className='data-list__item'>
                <span className='data-list__item__label'>Quantity</span>
                <span className='data-list__item__value'>{getUsCurrencyFormatWithoutDecimal(Number(quantity) || 0)} shares</span>
              </div>
              <div className='data-list__item'>
                <span className='data-list__item__label'>Avg price paid</span>
                <span className='data-list__item__value'>${getUsCurrencyFormat(Number(averagePrice) || 0)}</span>
              </div>
              <div className='data-list__item'>
                <span className='data-list__item__label'>Portfolio volume</span>
                <span className='data-list__item__value'>{getUsPercentageFormat(Number(portfolioVolume) || 0)}% </span>
              </div>
              <div className='data-list__item'>
                <span className='data-list__item__label'>Equity</span>
                <span className='data-list__item__value'>{getUsPercentageFormat(Number(equity) || 0)}% </span>
              </div>
            </div>
          </div>
          <hr className='mb-48 mt-56 hr' />
          <div className='asset-detail'>
            <div className='graph'>
              <div className='graph'>
                <div className='timeline'>
                  {React.Children.toArray(
                    timelineLabels.map((label) => {
                      return (
                        <span
                          onClick={() => {
                            handleSelectTimeline(label);
                          }}
                          className={`timeline__item ${label === selectedTimeline ? 'active' : ''}`}
                        >
                          {label}
                        </span>
                      );
                    })
                  )}
                </div>
              </div>
              <Spin spinning={false} wrapperClassName='graph__spin'>
                <PortfolioBarchart
                  data={chartData}
                  interval={portfolioBarchartInterval}
                  isShowFullDate={isShowFullDate}
                />
              </Spin>
            </div>
            <div className='data'>
              <p className='fw-600 fz-16'>Investment summary</p>
              <div className='data__item'>
                <Tooltip title='The total amount you have paid for each share that you currently own.'>
                  <span className='data__item__label tooltip'>
                    Total investment
                    <span>
                      <Info marginLeft='8px' verticalAlign='middle' />
                    </span>
                  </span>
                </Tooltip>
                <span className='data__item__value'>${getUsCurrencyFormat(Number(totalInvestment) || 0)}</span>
              </div>
              <div className='data__item'>
                {/* <Tooltip title='The increase in the value of all asset shares you own that has yet to be sold for cash.'> */}
                <span className='data__item__label tooltip'>Total gain</span>
                {/* </Tooltip> */}
                <span className='data__item__value'>${getUsCurrencyFormat(Number(totalGain) || 0)}</span>
              </div>
              <div className='data__item'>
                <Tooltip title='The increase in the value of all asset shares you own that has yet to be sold for cash.'>
                  <span className='data__item__label tooltip'>
                    Unrealized gain
                    <span>
                      <Info marginLeft='8px' verticalAlign='middle' />
                    </span>
                  </span>
                </Tooltip>
                <span className='data__item__value'>${getUsCurrencyFormat(Number(unrealizedGain) || 0)}</span>
              </div>
            </div>
            <div className='data'>
              <p className='fw-600 fz-16'>Dividends received</p>
              <div className='data__item'>
                <span className='data__item__label tooltip'>Last dividend</span>

                <span className='data__item__value'>${getUsCurrencyFormat(Number(lastDividend) || 0)}</span>
              </div>
              <div className='data__item'>
                <span className='data__item__label tooltip'>Next dividend</span>
                <span className='data__item__value'>
                  {getDateFormat({
                    date: new Date(nextDividend),
                    options: {
                      month: 'short',
                      day: 'numeric',
                      year: 'numeric',
                    },
                  })}
                </span>
              </div>
              <div className='data__item'>
                <span className='data__item__label tooltip'>Average yield</span>
                <span className='data__item__value'>{getUsCurrencyFormat(Number(averageYield) || 0)}%</span>
              </div>
              <div className='data__item'>
                <span className='data__item__label tooltip'>All time earnings</span>
                <span className='data__item__value'>${getUsCurrencyFormat(Number(allTimeEarning) || 0)}</span>
              </div>
            </div>
            <hr className='mb-40 hr' />
            <div className='data'>
              <div className='data__title'>
                <span className='data__title__label fw-600 fz-16'>Current share data</span>
                <Link
                  to={{
                    pathname: `/property/secondary/${propertyId}/details`,
                    hash: 'portfolio-assets',
                  }}
                  className='data__title__value fw-600'
                >
                  See all <NextArrow verticalAlign='initial' color='#C04F0F' size='10' />
                </Link>
              </div>
              <div className='data__item'>
                <span className='data__item__label tooltip'>Lowest ask</span>
                <span className='data__item__value'>${getUsCurrencyFormat(Number(lowestAsk) || 0)}</span>
              </div>
              <div className='data__item'>
                <span className='data__item__label tooltip'>Highest bid</span>
                <span className='data__item__value'>${getUsCurrencyFormat(Number(highestBid) || 0)}</span>
              </div>
              <div className='data__item'>
                <span className='data__item__label tooltip'>52 week low</span>
                <span className='data__item__value'>${getUsCurrencyFormat(Number(low52week) || 0)}</span>
              </div>
              <div className='data__item'>
                <span className='data__item__label tooltip'>52 week high</span>
                <span className='data__item__value'>${getUsCurrencyFormat(Number(high52week) || 0)}</span>
              </div>
              <div className='data__item'>
                <span className='data__item__label tooltip'>Last dividend per share</span>
                <span className='data__item__value'>${getUsCurrencyFormat(Number(lastDividendPerShare) || 0)}</span>
              </div>
            </div>
          </div>
        </Spin>
      </div>
      <NotifyMeModal
        open={open}
        setOpen={setOpen}
        email={email}
        setEmail={setEmail}
        newsLetterChecked={newsLetterChecked}
        setNewsLetterChecked={setNewsLetterChecked}
        handleNotifyMe={handleNotifyMe}
        ref={formRef}
      />
      <MarketFooter />
    </>
  );
};
export default AssetDetails;
